/* tslint:disable:max-line-length */
import React, { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import { useCommonWidgetHandlers } from '../../../../../../../../../../common/helpers/widget-helpers/use-common-widget-handlers';
import WidgetModel from '@mm/state/model/WidgetModel';
import { NodeProps } from 'react-flow-renderer';
import css from './ReviewBadge.module.css';
import { useAutomationActions } from '@mm/state/actions/automationActions';
import { selectWidgets } from '@mm/state/selectors/widgetSelectors';
import classNames from 'classnames';
import { widgetToNodeType } from '../../../use-graph';
import { NodeTypes } from '../../index';
import { ExclamationCircleFilled } from '@ant-design/icons';

const getBadgeStyle = (widget: WidgetModel) => {
  const type = widgetToNodeType(widget);

  switch (type) {
    case NodeTypes.CONDITION: {
      return {
        right: 115,
      };
    }
    default: {
      return {};
    }
  }
};

export const ReviewBadge = ({
  className,
  onClick,
  withIcon = false,
  text = 'Review',
  ...props
}: {
  className?: string;
  onClick?: () => void;
  style?: CSSProperties;
  withIcon?: boolean;
  text?: string;
}) => {
  return (
    <span
      {...props}
      className={classNames(className, css.badge, 'js-review-badge')}
      onClick={onClick}
    >
      {withIcon && <ExclamationCircleFilled className={css.icon} />}
      {text}
    </span>
  );
};

export const withReviewBadge =
  (
    Component: React.FC<
      NodeProps<{ widget: WidgetModel }> & { className?: string }
    >,
  ) =>
  props => {
    const widgets = useSelector(selectWidgets);
    const widget =
      widgets.find(w => w.id === props.data.widget.id) || props.data.widget;

    const automationActions = useAutomationActions();
    const commonWidgetHandlers = useCommonWidgetHandlers();

    const toggleReviewStatus = async () => {
      if (widget.needsReview) {
        try {
          await commonWidgetHandlers.updateField(widget, 'needsReview', false);
          automationActions.decreaseReviewRequiredCount();
        } catch (err) {
          console.error(err);
        }
      }
    };

    const style = getBadgeStyle(widget);

    return (
      <div className={classNames(css.container, props?.className)}>
        {widget.needsReview && (
          <ReviewBadge
            style={style}
            onClick={() => {
              automationActions.pushActionToOpen({ widgetId: widget.id });
              toggleReviewStatus();
            }}
          />
        )}
        <span onClick={toggleReviewStatus}>
          <Component {...props} />
        </span>
      </div>
    );
  };
